export default "__VITE_ASSET__f7454f5d__"